import React, { useState } from "react";
import { Player } from "video-react";
import { iconData } from "../../../../iconData";
import PdfViewer from "../../../PdfViewer/PdfViewer";
import { IP } from "../../../../internalServer";
import ZoomableImage from "../../Pending/QuestionTypes/ZoomableImage";

export default function CheckBoxType({ response, questionNo, type }) {
  const [isClicked, setIsClicked] = useState(false);
  const [responseAttach, setResponseAttach] = useState();
  const [isError, setIsError] = useState(false);
  const [pedingSubDetail, setPedingSubDetail] = useState({
    pdfView: false,
  });
  const handleRemovePdfVivwer = () => {
    setPedingSubDetail({
      ...pedingSubDetail,
      pdfView: false,
    });
  };
  const handleClick = (attachment) => {
    setResponseAttach(attachment);
    setIsClicked(!isClicked);
  };

  const poster =
    "https://images.unsplash.com/photo-1431499012454-31a9601150c9?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80";

  // console.log("response : ", response);
  return (
    <>
      <div className="containerBelowQuestion">
        <div className="d-flex justify-content-between">
          <div className="Question">
            Q{questionNo}.  {response?.question_response?.question?.title?.split("\n").map((line, index) => (
              <React.Fragment key={index}>
                {index !== 0 && <br />}
                <span style={index !== 0 ? { marginLeft: "30px", display: "inline-block" } : {}}>
                  {line}
                </span>
              </React.Fragment>
            ))}
          </div>
          {/* <div className="marksQue">
            {response?.question_response?.question?.correct_score} Marks
          </div> */}
        </div>

        {response?.question_response?.question?.attachments?.length > 0 &&
          response?.question_response?.question?.attachments?.map(
            (attachment, index) => (
              <div key={index}>
                {attachment.split(".").pop() !== "mp4" ? (
                  <>
                    {attachment.split(".").pop() === "jpg" ||
                      attachment.split(".").pop() === "jpeg" ||
                      attachment.split(".").pop() === "JPEG" ||
                      attachment.split(".").pop() === "JPG" ||
                      attachment.split(".").pop() === "PNG" ||
                      attachment.split(".").pop() === "png" ? (
                      <img
                        style={{ cursor: "pointer" }}
                        className="mt-3 imageWidthAndHeight"
                        src={IP + attachment?.replace(/^\./, "")}
                        alt="Attachment"
                        onClick={() => {
                          if (!isError) {
                            handleClick(attachment);
                          }
                        }}
                      />
                    ) : (
                      <div
                        key={index}
                        onClick={(e) => {
                          if (attachment.split(".").pop() === "mp3") {
                            handleClick(attachment);
                          } else {
                            setPedingSubDetail({
                              ...pedingSubDetail,
                              pdfView: true,
                              attachment: attachment,
                            });
                          }
                        }}
                        className="mt-2"
                      >
                        <div className="d-flex pdfContainer gap-2 p-2 ">
                          <div className="d-flex align-items-center">
                            <img
                              className="extention_icon"
                              src={`${iconData?.find(
                                (i) =>
                                  i.extension ===
                                  attachment?.match(/\.([^.]+)$/)[1]
                              )?.icon
                                }`}
                              alt=""
                            />
                          </div>
                          <div className="w-100">
                            <div className="pdfName">
                              {attachment?.replace(/^[^_]*_/, "")}
                            </div>
                            <div className="pdfFileSize">12 KB</div>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  <div className="d-flex pdfContainer gap-2 p-2 "
                    onClick={() => {
                      if (!isError) {
                        handleClick(attachment);
                      }
                    }}>
                    <div className="d-flex align-items-center">
                      <img
                        className="extention_icon"
                        src={`${iconData?.find(
                          (i) =>
                            i.extension ===
                            attachment?.match(/\.([^.]+)$/)[1]
                        )?.icon
                          }`}
                        alt=""
                      />
                    </div>
                    <div className="w-100">
                      <div className="pdfName">
                        {attachment?.replace(/^[^_]*_/, "")}
                      </div>
                      <div className="pdfFileSize">12 KB</div>
                    </div>
                  </div>
                )}
              </div>
            )
          )
        }
        {response?.question_response?.b4sQuestion?.attachments?.length > 0 &&
          response?.question_response?.b4sQuestion?.attachments?.map(
            (attachment, index) => (
              <div key={index}>
                {attachment.split(".").pop() !== "mp4" ? (
                  <>
                    {attachment.split(".").pop() === "jpg" ||
                      attachment.split(".").pop() === "jpeg" ||
                      attachment.split(".").pop() === "JPEG" ||
                      attachment.split(".").pop() === "JPG" ||
                      attachment.split(".").pop() === "PNG" ||
                      attachment.split(".").pop() === "png" ? (
                      <img
                        style={{ cursor: "pointer" }}
                        className="mt-3 imageWidthAndHeight"
                        src={IP + attachment?.replace(/^\./, "")}
                        alt="Attachment"
                        onClick={() => {
                          if (!isError) {
                            handleClick(attachment);
                          }
                        }}
                      />
                    ) : (
                      <div
                        key={index}
                        onClick={(e) => {
                          setPedingSubDetail({
                            ...pedingSubDetail,
                            pdfView: true,
                            attachment: attachment,
                          });
                        }}
                        className="mt-2"
                      >
                        <div className="d-flex pdfContainer gap-2 p-2 ">
                          <div className="d-flex align-items-center">
                            <img
                              className="extention_icon"
                              src={`${iconData?.find(
                                (i) =>
                                  i.extension ===
                                  attachment?.match(/\.([^.]+)$/)[1]
                              )?.icon
                                }`}
                              alt=""
                            />
                          </div>
                          <div className="w-100">
                            <div className="pdfName">
                              {attachment?.replace(/^[^_]*_/, "")}
                            </div>
                            <div className="pdfFileSize">12 KB</div>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  <div className="d-flex pdfContainer gap-2 p-2 "
                    onClick={() => {
                      if (!isError) {
                        handleClick(attachment);
                      }
                    }}>
                    <div className="d-flex align-items-center">
                      <img
                        className="extention_icon"
                        src={`${iconData?.find(
                          (i) =>
                            i.extension ===
                            attachment?.match(/\.([^.]+)$/)[1]
                        )?.icon
                          }`}
                        alt=""
                      />
                    </div>
                    <div className="w-100">
                      <div className="pdfName">
                        {attachment?.replace(/^[^_]*_/, "")}
                      </div>
                      <div className="pdfFileSize">12 KB</div>
                    </div>
                  </div>
                )}
              </div>
            )
          )
        }
        {/*  */}
        <div className="mt-4  optionContainer">
          {/* {console.log("response?.question_response", response?.question_response)} */}
          {response?.question_response?.question?.options?.length > 0 &&
            response?.question_response?.question?.options?.map((option) => {
              return (
                <>
                  <div
                    key={option?.key}
                    className={`d-flex justify-content-between align-items-center ${type == "SA" ? response?.question_response?.question?.correct_answers?.map(
                      (cAnswer) =>
                        cAnswer?.optionKey === option?.key
                          ? "totalContainerCheckboxCorrectAnswer"
                          : cAnswer?.optionKey !==
                            response?.question_response?.answer?.key &&
                            response?.question_response?.answer?.key === option?.key
                            ? "totalContainerCheckboxWrongAnswer"
                            : "totalContainerCheckboxNotAnswer"
                    )
                      :
                      response?.question_response?.question?.correct_answers?.map(
                        (cAnswer) =>
                          cAnswer?.option_key === option?.key
                            ? "totalContainerCheckboxCorrectAnswer"
                            : cAnswer?.option_key !==
                              response?.question_response?.answer?.key &&
                              response?.question_response?.answer?.key === option?.key
                              ? "totalContainerCheckboxWrongAnswer"
                              : "totalContainerCheckboxNotAnswer"
                      )
                      }`
                    }
                  >
                    <div className="d-flex align-items-center gap-3 ">
                      <div className="d-flex">
                        {
                          option?.key + ". "
                        }
                        <input
                          type="checkbox"
                          readOnly
                          checked={
                            response?.question_response?.answer?.key ===
                            option?.key ||
                            response?.question_response?.question?.correct_answers?.some(
                              (cAnswer) => cAnswer?.option_key === option?.key
                            ) ||
                            false
                          }
                          className={`${response?.question_response?.question?.correct_answers?.some(
                            (cAnswer) => type == "SA" ? cAnswer?.optionKey === option?.key : cAnswer?.option_key === option?.key
                          )
                            ? "CorrectAnswerCheckbox"
                            : "WrongAnswerCheckbox"
                            } d-flex align-items-center ml-2 mt-1`}
                        />
                      </div>
                      <div className="QueOptionsChecked d-flex align-items-center">
                        {option?.value}
                      </div>
                    </div>
                    {type == "SA" ? response?.question_response?.answer?.key === option?.key && (
                      <div
                        className={` ${response?.question_response?.question?.correct_answers?.map(
                          (cAnswer) =>
                            cAnswer?.optionKey === option?.key
                              ? "CorrectAnswerText"
                              : "yourAnswerText"
                        )}`}
                      >
                        Your answer
                      </div>
                    ) : response?.question_response?.answer?.key === option?.key && (
                      <div
                        className={` ${response?.question_response?.question?.correct_answers?.map(
                          (cAnswer) =>
                            cAnswer?.option_key === option?.key
                              ? "CorrectAnswerText"
                              : "yourAnswerText"
                        )}`}
                      >
                        Your answer
                      </div>
                    )}
                    {
                      type == "SA" ? response?.question_response?.question?.correct_answers
                        ?.length > 0 &&
                        response?.question_response?.question?.correct_answers?.map(
                          (cAnswer) =>
                            cAnswer?.optionKey === option?.key && (
                              <div className="CorrectAnswerText">Correct answer </div>
                            )
                        ) :
                        response?.question_response?.question?.correct_answers
                          ?.length > 0 &&
                        response?.question_response?.question?.correct_answers?.map(
                          (cAnswer) =>
                            cAnswer?.option_key === option?.key && (
                              <div className="CorrectAnswerText">Correct answer </div>
                            )
                        )
                    }
                  </div>
                  <div className="ml-8 mt-1">
                    {option.attachment &&
                      (() => {
                        const ext = option.attachment.split(".").pop().toLowerCase();
                        const isImage = ["jpg", "jpeg", "png"].includes(ext);
                        return isImage ? (
                          <ZoomableImage src={option.attachment} />
                        ) : null;
                      })()}
                  </div>
                </>
              )
            })
          }
          {response?.question_response?.b4sQuestion?.options?.length > 0 &&
            response?.question_response?.b4sQuestion?.options?.map((option) => (
              <div
                key={option?.key}
                style={{ marginBottom: "7px" }}
                className={`d-flex justify-content-between align-items-center ${type == "SA" ? response?.question_response.b4sQuestion.correct_answers?.map(
                  (cAnswer) =>
                    cAnswer?.optionKey === option?.key
                      ? "totalContainerCheckboxCorrectAnswer"
                      : cAnswer?.optionKey !==
                        response?.question_response?.answer?.key &&
                        response?.question_response?.answer?.key === option?.key
                        ? "totalContainerCheckboxWrongAnswer"
                        : "totalContainerCheckboxNotAnswer"

                )
                  :
                  response?.question_response?.question?.correct_answers?.map(
                    (cAnswer) =>
                      cAnswer?.option_key === option?.key
                        ? "totalContainerCheckboxCorrectAnswer"
                        : cAnswer?.option_key !==
                          response?.question_response?.answer?.key &&
                          response?.question_response?.answer?.key === option?.key
                          ? "totalContainerCheckboxWrongAnswer"
                          : "totalContainerCheckboxNotAnswer"
                  )
                  }`
                }
              >
                <div className="d-flex align-items-center gap-3 ">
                  <div className="d-flex">
                    {
                      option?.key + ". "
                    }
                    <input
                      type="checkbox"
                      readOnly
                      checked={
                        response?.question_response?.answer?.key ===
                        option?.key ||
                        response?.question_response.b4sQuestion.correct_answers?.some(
                          (cAnswer) => cAnswer?.optionKey === option?.key
                        ) ||
                        false
                      }
                      className={`${response?.question_response.b4sQuestion.correct_answers?.some(
                        (cAnswer) => type == "SA" ? cAnswer?.optionKey === option?.key : cAnswer?.option_key === option?.key
                      )
                        ? "CorrectAnswerCheckbox"
                        : "WrongAnswerCheckbox"
                        } d-flex align-items-center ml-2 mt-1`}
                    />
                  </div>
                  <div className="QueOptionsChecked d-flex align-items-center">
                    {option?.value}
                  </div>
                </div>
                {/* {console.log("response?.question_response123", response?.question_response)}
                {console.log("response?.question_response.b4sQuestion.correct_answers", response?.question_response.b4sQuestion.correct_answers)}
                {console.log("option?.key", option?.key)} */}
                {type == "SA" ? response?.question_response?.answer?.key === option?.key && (
                  <div
                    className={` ${response?.question_response?.b4sQuestion?.correct_answers?.map(
                      (cAnswer) =>
                        cAnswer?.optionKey === option?.key
                          ? "CorrectAnswerText"
                          : "yourAnswerText"
                    )}`}
                  >
                    Your answer
                  </div>
                ) : response?.question_response?.answer?.key === option?.key && (
                  <div
                    className={` ${response?.question_response?.question?.correct_answers?.map(
                      (cAnswer) =>
                        cAnswer?.option_key === option?.key
                          ? "CorrectAnswerText"
                          : "yourAnswerText"
                    )}`}
                  >
                    Your answer
                  </div>
                )}
                {
                  response?.question_response?.answer?.key === " "
                    ?
                    <div className="d-flex align-items-center">
                      <img src="/images/wrong_icon.svg" alt="" />
                      <div className="m-2 wrong">Sturent Not Answered</div>
                    </div>
                    :
                    (type == "SA" ? response?.question_response.b4sQuestion.correct_answers
                      ?.length > 0 &&
                      response?.question_response.b4sQuestion.correct_answers?.map(
                        (cAnswer) =>
                          cAnswer?.optionKey === option?.key && (
                            <div className="CorrectAnswerText">Correct answer </div>
                          )
                      ) :
                      response?.question_response?.question?.correct_answers
                        ?.length > 0 &&
                      response?.question_response?.question?.correct_answers?.map(
                        (cAnswer) =>
                          cAnswer?.option_key === option?.key && (
                            <div className="CorrectAnswerText">Correct answer </div>
                          )
                      ))
                }
              </div>
            ))
          }
        </div>
        {
          response?.question_response?.answer?.key === " " ? (
            <div className="d-flex align-items-center">
              <img src="/images/wrong_icon.svg" alt="" />
              <div className="m-2 wrong">Student Not Answered</div>
            </div>
          ) : type == "SA" ? (
            response?.question_response?.question !== undefined ? (
              response?.question_response?.question?.correct_answers?.some(
                (cAnswer) => cAnswer?.optionKey === response?.question_response?.answer?.key
              ) ? (
                // If at least one correct answer matches, mark as Correct
                <div className="mt-4">
                  <div className="d-flex align-items-center gap-2">
                    <div className="d-flex align-items-center">
                      <img src="/HwImg/checkIcon.svg" alt="" />
                    </div>
                    <div className="Correct">Correct</div>
                  </div>
                </div>
              ) : (
                // If no correct answer matches, mark as Wrong
                <div className="mt-4">
                  <div className="d-flex align-items-center gap-2">
                    <div className="d-flex align-items-center">
                      <img src="/HwImg/WrongAnswerIcon.png" alt="" />
                    </div>
                    <div className="wrong">Wrong</div>
                  </div>
                </div>
              )
            ) : response?.question_response?.b4sQuestion?.correct_answers?.some(
              (cAnswer) => cAnswer?.optionKey === response?.question_response?.answer?.key
            ) ? (
              <div className="mt-4">
                <div className="d-flex align-items-center gap-2">
                  <div className="d-flex align-items-center">
                    <img src="/HwImg/checkIcon.svg" alt="" />
                  </div>
                  <div className="Correct">Correct</div>
                </div>
              </div>
            ) : (
              <div className="mt-4">
                <div className="d-flex align-items-center gap-2">
                  <div className="d-flex align-items-center">
                    <img src="/HwImg/WrongAnswerIcon.png" alt="" />
                  </div>
                  <div className="wrong">Wrong</div>
                </div>
              </div>
            )
          ) : response?.question_response?.question?.correct_answers?.some(
            (cAnswer) => cAnswer?.option_key === response?.question_response?.answer?.key
          ) ? (
            <div className="mt-4">
              <div className="d-flex align-items-center gap-2">
                <div className="d-flex align-items-center">
                  <img src="/HwImg/checkIcon.svg" alt="" />
                </div>
                <div className="Correct">Correct</div>
              </div>
            </div>
          ) : (
            <div className="mt-4">
              <div className="d-flex align-items-center gap-2">
                <div className="d-flex align-items-center">
                  <img src="/HwImg/WrongAnswerIcon.png" alt="" />
                </div>
                <div className="wrong">Wrong</div>
              </div>
            </div>
          )
        }

        {/* <div className='mt-4'>
                <div className='d-flex align-items-center gap-2'>
                    <div className='d-flex align-items-center'>
                        <img src='/HwImg/CoorectAnswerIcon.png ' alt=''/>  
                    </div>
                    <div className='Corect'>Correct</div>
                </div>
            </div> */}

        {!type == "SA" && <div className="mt-4 pt-2">
          <div className="TeacherRemarkHeader">TEACHER’S REMARK</div>
          <div className="TeacerRemarkText mt-2">{response?.comment}</div>
        </div>}
      </div>
      {pedingSubDetail.pdfView && (
        <PdfViewer
          handleRemovePdfVivwer={handleRemovePdfVivwer}
          attachment={pedingSubDetail?.attachment}
        />
      )}
      {isClicked &&
        (responseAttach.split(".").pop() === "mp4" || responseAttach.split(".").pop() === "MP4" ? (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              <video className="videoPlayer" controls>
                <source src={IP + responseAttach.replace(/^\./, "")} type="video/mp4" />
              </video>
              <div>
                <img
                  className="crossIconImgQue"
                  onClick={handleClick}
                  src="/DCM-img/crossIcon.svg"
                  alt="Up Arrow"
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              {
                !isError ? (
                  <>

                    <img
                      className="imgMain"
                      src={IP + responseAttach?.replace(/^\./, "")}
                      alt="Full-size"
                      onError={(e) => {
                        setIsError(true)
                      }}
                    />
                    <div>
                      <img
                        className="crossIconImgQue"
                        onClick={handleClick}
                        src="/images/cross.png"
                        alt="Up Arrow"
                      />
                    </div>
                  </>
                ) : (
                  <div className="fullSizeImg" style={{ display: "flex", flexDirection: "column" }}>

                    <img
                      onClick={handleClick}
                      src="/images/cross.png"
                      alt="Up Arrow"
                      style={{ position: "absolute", top: "75px", right: "40%" }}
                    />
                    <img src="/images/no-photo1.png" alt="img" style={{ width: "25%" }} />
                    <p style={{ color: "red", fontSize: "20px", fontWeight: "500", marginRight: "35px" }}>Error!! failed to load the requested file!</p>
                  </div>
                )
              }
            </div>
          </div>
        ))}
    </>
  );
}
